/*
 * Copyright (c) Harness Inc.
 *
 * This source code is licensed under the Apache 2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { createContext } from 'react'

interface FormikTooltipContextInterface {
  formName: string
}

export const FormikTooltipContext = createContext<FormikTooltipContextInterface>({ formName: '' })
